<script setup lang="ts">
import { useField } from 'vee-validate';
import TInput from '../../Input/TInput.vue';
import type { FormInputProps } from './form-input';
import FormFieldError from './FormFieldError.vue';
import type { ValidatorRule } from '../validation-rules';
import { validateRequired, validateUrl } from '../validation-rules';
import { onMounted, ref } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<FormInputProps>();

const rules: ValidatorRule[] = [];
const field = useField<string>(props.name, rules);
const inputRef = ref<HTMLInputElement | null>(null);

if (props.required) {
  rules.push(validateRequired);
}

if (props.url) {
  rules.push(validateUrl);
}

if (props.validators?.length) {
  rules.push(...props.validators);
}

onMounted(() => {
  if (props.autofocus) {
    inputRef.value?.focus();
  }
});
</script>

<template>
  <div class="relative flex w-full flex-col">
    <TInput
      v-bind="$attrs"
      ref="inputRef"
      :type="props.type || 'text'"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      :value="field.value.value"
      emit-change-on-input
      :placeholder="props.placeholder"
      :readonly="props.readonly"
      :disabled="props.disabled"
      @change="(value: string) => field.setValue(value)"
    />
    <FormFieldError
      v-if="props.error || field.errorMessage.value"
      :message="props.error || field.errorMessage.value || ''"
    />
  </div>
</template>
